import Swiper from 'swiper/dist/js/swiper.min.js';

$(window).on('load', () => {
  if (!$('.swiper-careers').length) {
    return;
  }

  careersSlider();

  if ($('.slider-careers.text-hover').length && $(window).width() > 767) {
    careersHover();
  }
});

function careersSlider() {
  if ($('.swiper-careers .swiper-slide').length > 1) {
    new Swiper('.swiper-careers', {
      slidesPerView: 1,
      loop: true,
      updateOnImagesReady: true,
      autoplay: {
        delay: 6000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }
}

function careersHover() {
  //var titleFontSize = $('.slider-careers .title').css('font-size'),
      //contentFontSize = '20px';

  $('.slider-careers .title').mouseenter(function() {
    $(this).css('transform', 'translate3d(0, 0, 0)');
    $(this).parent().find('.content').css('opacity', 1).css('transform', 'scale(1)').css('height', 'auto');
  });

  $('.slider-careers .content').mouseleave(function() {
    $(this).parent().find('.title').css('transform', 'translate3d(0, 30%, 0)');
    $(this).parent().find('.content').css('opacity', 0).css('transform', 'scale(0)').css('height', '0');
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/careers-slider.js